import ReactSelect from 'react-select';
import Async from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import CreatableSelect from 'react-select/creatable';
import { styled, css } from 'styled-components';
import { Media } from '../../../theme/Media';
export const FIXED_MULTI_VALUE_CLASS = 'select__multi-value--fixed';
export const CheckWrapper = styled.div `
  min-width: 24px;
  display: flex;
`;
const styles = css `
  width: 100%;
  // Fix to make text-overflow: ellipsis work correctly in Firefox
  min-width: 0;
  & .select__control {
    ${({ theme }) => theme.typography.textMedium};
    padding: 0;
    border-radius: 8px;
    border-color: ${({ theme }) => theme.colors.grey30_1};
    background: ${({ theme }) => theme.colors.grey00_7};

    &:hover {
      border-color: ${({ theme }) => theme.colors.grey70_1};
      cursor: pointer;
    }

    &--is-disabled {
      background-color: ${({ theme }) => theme.colors.grey05_4};
      border-color: ${({ theme }) => theme.colors.grey30_2};
      pointer-events: none;

      .select__placeholder {
        color: ${({ theme }) => theme.colors.grey100_2};
      }
    }

    &--is-focused {
      ${({ theme }) => css `
        ${theme.shadows.focus}
        border-color: ${theme.colors.main};

        &:hover {
          border-color: ${theme.colors.main};
        }
      `}
    }
  }

  &.select--is-disabled {
    cursor: not-allowed;
    pointer-events: initial;

    .select__indicator.select__dropdown-indicator {
      svg > path:not([fill='transparent']) {
        fill: ${({ theme }) => theme.colors.grey30_1};
      }
    }
  }

  & .select__indicators {
    margin-bottom: auto;

    .select__indicator-separator {
      display: none;
    }
  }

  & .select__placeholder {
    margin: 0;
    color: ${({ theme }) => theme.colors.grey70_1};
  }

  & .select__value-container {
    padding: 0px 12px;

    & .select__input-container {
      color: ${({ theme }) => theme.colors.black_1};
    }

    &.select__value-container--is-multi {
      padding: 5px 8px;
      gap: 8px 4px;

      .select__input-container {
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    & .select__single-value {
      color: ${({ theme }) => theme.colors.black_1};
      &--is-disabled {
        color: ${({ theme }) => theme.colors.grey100_2};
      }
    }

    .campaign-page & {
      height: auto;
      @media ${Media.smMin} {
        height: 30px;
      }
    }
  }

  & .select__indicator.select__dropdown-indicator {
    margin-right: 12px;
    padding: 7px 0;

    svg > path:not([fill='transparent']) {
      fill: ${({ theme }) => theme.colors.grey100_1};
    }
  }

  & .select__clear-indicator {
    padding: 7px 8px 7px 0;

    svg > path:not([fill='transparent']) {
      fill: ${({ theme }) => theme.colors.grey70_1};
    }
  }

  & .select__control.select__control--menu-is-open .select__dropdown-indicator {
    transform: rotate(180deg);
  }

  & .select__multi-value {
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.grey10_1};
    background: ${({ theme }) => theme.colors.grey05_2};
    margin: 0;
    ${({ theme }) => theme.typography.textMedium}

    .select__multi-value__label {
      padding: 1px 8px;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.black_1};
    }

    .select__multi-value__remove {
      padding-left: 0;

      svg > path:not([fill='transparent']) {
        fill: ${({ theme }) => theme.colors.grey100_1};
      }

      &:hover {
        background: none;
        cursor: pointer;

        svg > path:not([fill='transparent']) {
          fill: ${({ theme }) => theme.colors.black_1};
        }
      }
    }

    &--is-disabled,
    &.${FIXED_MULTI_VALUE_CLASS} {
      background: ${({ theme }) => theme.colors.grey01_2};
      border-color: transparent;

      .select__multi-value__label {
        color: ${({ theme }) => theme.colors.grey70_3};
      }

      .select__multi-value__remove {
        cursor: not-allowed;

        svg > path:not([fill='transparent']) {
          fill: ${({ theme }) => theme.colors.grey70_3};
        }
      }
    }
  }
`;
export const MenuPortalWrapper = styled.div `
  & .select__option {
    padding: 10px 16px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.black_1};
    &--is-disabled {
      cursor: not-allowed;
    }
    @supports (-ms-ime-align: auto) {
      word-break: break-all;
    }
  }

  & .select__menu-notice--no-options {
    color: ${({ theme }) => theme.colors.grey100_2};
  }

  & .select__option--is-selected {
    background: ${({ theme }) => theme.colors.grey05_1};
    color: ${({ theme }) => theme.colors.black_1};
  }

  & .select__option--is-focused.select__option--is-selected {
    background: ${({ theme }) => theme.colors.grey05_1};
  }

  & .select__option--is-focused {
    background: ${({ theme }) => theme.colors.grey05_1};
  }

  & .select__option--is-disabled {
    background: ${({ theme }) => theme.colors.grey01_3};
    color: ${({ theme }) => theme.colors.grey100_2};

    ${CheckWrapper} path {
      fill: ${({ theme }) => theme.colors.grey100_2};
    }
  }

  & .select__option:hover:not(.select__option--is-disabled) {
    background: ${({ theme }) => theme.colors.grey05_1};
  }

  & .select__menu {
    margin-bottom: 4px;
    margin-top: 4px;
    border-radius: 8px;
    ${({ theme }) => theme.shadows.large}
    border: 0;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.grey00_6};
    & .select__menu-list {
      background-color: ${({ theme }) => theme.colors.grey00_6};
    }
  }
`;
export const MenuListContent = styled.div `
  display: inline-flex;
  width: 100%;
  flex-direction: column;
`;
const errorStyles = css `
  & .select__control {
    border-color: ${({ theme }) => theme.colors.critical70};

    &--is-focused {
      ${({ theme }) => theme.shadows.error}
    }

    &:hover {
      border-color: ${({ theme }) => theme.colors.critical70};
    }
  }
`;
const warningStyles = css `
  & .select__control {
    border-color: ${({ theme }) => theme.colors.warning70};

    &--is-focused {
      ${({ theme }) => theme.shadows.warning}
    }

    &:hover {
      border-color: ${({ theme }) => theme.colors.warning70};
    }
  }
`;
export const StyledSelect = styled(ReactSelect) `
  ${styles};
  ${({ error }) => error && errorStyles}
  ${({ warning }) => warning && warningStyles}
`;
export const SAsyncSelect = styled(Async) `
  ${styles};
  ${({ error }) => error && errorStyles}
  ${({ warning }) => warning && warningStyles}
`;
export const SCreatableSelect = styled(CreatableSelect) `
  ${styles};
  ${({ error }) => error && errorStyles}
  ${({ warning }) => warning && warningStyles}
`;
export const SAsyncCreatableSelect = styled(AsyncCreatableSelect) `
  ${styles};
  ${({ error }) => error && errorStyles}
  ${({ warning }) => warning && warningStyles}
`;
export const LoaderWrapper = styled.div `
  display: flex;
  align-items: center;
  padding-right: 8px;
`;
export const OptionTitle = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const OptionDescription = styled.div `
  color: ${({ theme }) => theme.colors.grey100_1};
  margin-top: 4px;
`;
